import EntityModel from '@/common/models/entity-model';

export default class ContactPhoneEmailItemsModel extends EntityModel {
    static Labels = {
        primary: 'Primary',
        main: 'Main',
        home: 'Home',
        work: 'Work',
        mobile: 'Mobile',
        pager: 'Pager',
        homeFax: 'Home Fax',
        workFax: 'Work Fax',
        other: 'Other',
    };

    static PhoneLabels = [
        ContactPhoneEmailItemsModel.Labels.main,
        ContactPhoneEmailItemsModel.Labels.home,
        ContactPhoneEmailItemsModel.Labels.work,
        ContactPhoneEmailItemsModel.Labels.mobile,
        ContactPhoneEmailItemsModel.Labels.pager,
        ContactPhoneEmailItemsModel.Labels.homeFax,
        ContactPhoneEmailItemsModel.Labels.workFax,
        ContactPhoneEmailItemsModel.Labels.other,
    ];

    static EmailLabels = [
        ContactPhoneEmailItemsModel.Labels.main,
        ContactPhoneEmailItemsModel.Labels.home,
        ContactPhoneEmailItemsModel.Labels.work,
        ContactPhoneEmailItemsModel.Labels.other,
    ];

    hydrate({
        label = null,
        value = null,
        primary = false,
    } = {}) {
        this.label = label || ContactPhoneEmailItemsModel.Labels.main;
        this.value = value;
        this.primary = typeof primary === 'string' ? primary === 'true' : primary;
    }

    get isLabelPrimary() {
        return this.label === ContactPhoneEmailItemsModel.Labels.primary;
    }

    getPayload() {
        return {
            label: this.label,
            value: this.value,
            primary: this.primary,
        };
    }
}
